import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSelectedProfileData } from '../apiCalls/user'

export const fetchProfileById = createAsyncThunk(
  "labProfile/fetchById",
  async (id) => {
    const res = await getSelectedProfileData(id);
    // console.log(res, 'we get')
    return res;
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState: {
    currentUser: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    registerStart: (state) => {
      state.isFetching = true;
    },
    registerSuccess: (state, action) => {
      state.isFetching = false;
      state.currentUser = action.payload;
    },
    registerFailure: (state, action) => {
      state.isFetching = false;
      state.error = true;
    },
    loginStart: (state) => {
      state.isFetching = true;
    },
    loginSuccess: (state, action) => {
      state.isFetching = false;
      state.currentUser = action.payload;
    },
    loginFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    logout: (state) => {
      state.currentUser = null;
    },
    // get All
    getUserStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getUserSuccess: (state, action) => {
      state.isFetching = false;
      state.users = action.payload;
    },
    getUserFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchProfileById.pending, (state) => {
          state.isFetching = true;
          state.error = false;
        })
        .addCase(fetchProfileById.fulfilled, (state, action) => {
          state.isFetching = false;
          state.selectedProfile = action.payload;
        })
        .addCase(fetchProfileById.rejected, (state) => {
          state.isFetching = false;
          state.error = true;
        });
    },
  },
});

export const {
  registerStart,
  registerSuccess,
  registerFailure,
  loginStart,
  loginSuccess,
  loginFailure,
  getUserStart,
  getUserSuccess,
  getUserFailure,
  logout
} = userSlice.actions;
export default userSlice.reducer;
